/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wizard_Step_ExportInputs */

const en_wizard_step_export = /** @type {(inputs: Wizard_Step_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export the plan`)
};

const id_wizard_step_export = /** @type {(inputs: Wizard_Step_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor rencana`)
};

/**
* | output |
* | --- |
* | "Export the plan" |
*
* @param {Wizard_Step_ExportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const wizard_step_export = /** @type {((inputs?: Wizard_Step_ExportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wizard_Step_ExportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wizard_step_export(inputs)
	return en_wizard_step_export(inputs)
});